import { Link } from 'react-router';
import { fetchExhibitionArtworks } from '~/api/artworks';
import { artworksAsList } from '~/api/artworksAsList';
import { fetchExhibition } from '~/api/exhibitions';
import ExhibitionHeader from '~/components/exhibitions/exhibition-header';
import { Button } from '~/components/ui/button';
import { getLanguage } from '~/lib/i18n';
import { cn } from '~/lib/utils';
import type { Route } from './+types/exhibition-info';

export function meta() {
  // TODO: Implement meta tags for exhibition info page
  return [{ title: 'Ficha técnica' }, { name: 'description', content: '' }];
}

export async function loader({ params }: Route.LoaderArgs) {
  const exhibition = await fetchExhibition(params.id);
  const artworks = artworksAsList(await fetchExhibitionArtworks(params.id));
  return { exhibition, artworks };
}

export function ErrorBoundary({ error }: { error: Error }) {
  return (
    <div>
      <h1>Error</h1>
      <p>{error.message}</p>
    </div>
  );
}

export default function Exhibition({ params, loaderData }: Route.ComponentProps) {
  const { exhibition } = loaderData;
  const { curatorship } = exhibition;
  const lang = getLanguage(params.lang ?? exhibition.languages.at(0));
  const localizedContent = exhibition[lang];
  const description = (localizedContent.description ?? '').split('\r\n');
  const { sponsors } = localizedContent;
  // UI
  return (
    <div className="px-4 py-12 lg:px-40 bg-card">
      <ExhibitionHeader exhibition={exhibition} lang={lang} />
      <div className="mt-12">
        <Link to={`/exibicoes/${exhibition.id}/${lang}`}>
          <Button size="lg">Voltar para exposição</Button>
        </Link>
      </div>
      {description.length ? (
        <div className="mt-12">
          {description.map((line, index) => (
            <p key={index} className="mt-2 text-sm text-primary">
              {line}
            </p>
          ))}
        </div>
      ) : null}
      {curatorship ? (
        <div className="mt-8">
          <p className="text-sm text-primary">{curatorship}</p>
          <p className="text-sm text-primary">Curadoria</p>
        </div>
      ) : null}
      {sponsors ? (
        <img
          className={cn('mt-12 w-full h-full sm:max-w-[360px] sm:max-h-[360px]')}
          src={sponsors}
          alt="Patrocínio"
        />
      ) : null}
    </div>
  );
}
